import type {
  DeleteCheckResponse,
  DuplicateFlowFieldRequest,
  FlowField,
  SetFlowStatusRequest,
  SetFlowStatusResponse,
} from "@repo/shared/types";
import { get, patch, post } from "@/lib/api/_client";

const BASE = "/internal/flows";

/** QL-239 — move a flow to inactive / preview / active; the server validates a move into active. */
export function setFlowStatus(
  flowId: string,
  payload: SetFlowStatusRequest,
): Promise<SetFlowStatusResponse> {
  return patch<SetFlowStatusResponse>(
    `${BASE}/${flowId}/status`,
    payload satisfies SetFlowStatusRequest,
  );
}

/** QL-168 — asked when Delete is clicked on a flow field, before the confirmation opens. */
export function checkFieldDelete(flowId: string, fieldId: string): Promise<DeleteCheckResponse> {
  return get<DeleteCheckResponse>(`${BASE}/${flowId}/fields/${fieldId}/delete-check`);
}

/** QL-234 — copy a flow field into a new name and scope (scope is fixed once a field exists). */
export function duplicateField(
  flowId: string,
  fieldId: string,
  payload: DuplicateFlowFieldRequest,
): Promise<FlowField> {
  return post<FlowField>(
    `${BASE}/${flowId}/fields/${fieldId}/duplicate`,
    payload satisfies DuplicateFlowFieldRequest,
  );
}

/** QL-168 — asked when Delete is clicked on a flow page, before the confirmation opens. */
export function checkPageDelete(flowId: string, pageId: string): Promise<DeleteCheckResponse> {
  return get<DeleteCheckResponse>(`${BASE}/${flowId}/pages/${pageId}/delete-check`);
}

/** QL-168 — asked when Delete is clicked on a flow component, before the confirmation opens. */
export function checkComponentDelete(
  flowId: string,
  componentId: string,
): Promise<DeleteCheckResponse> {
  return get<DeleteCheckResponse>(`${BASE}/${flowId}/components/${componentId}/delete-check`);
}
